import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import SendIcon from "@mui/icons-material/Send";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import TableChartIcon from "@mui/icons-material/TableChart";
import SearchIcon from "@mui/icons-material/Search";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import {
  Badge,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grow,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel,
  Radio,
  useMediaQuery,
} from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";
import {
  AIExecutionAPI,
  AIGetSessionInputs,
  AIIntentListAPI,
  AIOneStepBackAPI,
  GetRecordApi,
  LoginAPI,
} from "../Util/UtilApi";
import { iframeConfig } from "../Util/UtilApi";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";

const getDeviceType = () => {
  const userAgent = navigator.userAgent;

  if (/Android|iPhone|iPad|iPod/i.test(userAgent)) {
    return "Mobile";
  }

  return "Web";
};

function TypewriterText({ text, speed = 18, onTick, onDone, renderAsHtml = false }) {
  const [displayed, setDisplayed] = useState("");
  const indexRef = useRef(0);

  useEffect(() => {
    setDisplayed("");
    indexRef.current = 0;

    if (!text) return;

    const interval = setInterval(() => {
      indexRef.current += 1;
      setDisplayed(text.slice(0, indexRef.current));
      onTick?.();

      if (indexRef.current >= text.length) {
        clearInterval(interval);
        onDone?.();
      }
    }, speed);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  if (renderAsHtml) {
    return (
      <Box
        dangerouslySetInnerHTML={{
          __html: displayed || "",
        }}
      />
    );
  }

  return <>{displayed}</>;
}

const inferControlType = (fieldName) => (/file/i.test(fieldName) ? "file" : fieldName);

const DEFAULT_COUNTRY_CODES = [
  { code: "1", name: "United States - US" },
  { code: "7", name: "Russia - RU" },
  { code: "20", name: "Egypt - EG" },
  { code: "27", name: "South Africa - ZA" },
  { code: "30", name: "Greece - GR" },
  { code: "31", name: "Netherlands - NL" },
  { code: "32", name: "Belgium - BE" },
  { code: "33", name: "France - FR" },
  { code: "34", name: "Spain - ES" },
  { code: "36", name: "Hungary - HU" },
  { code: "39", name: "Italy - IT" },
  { code: "40", name: "Romania - RO" },
  { code: "41", name: "Switzerland - CH" },
  { code: "43", name: "Austria - AT" },
  { code: "44", name: "United Kingdom - GB" },
  { code: "45", name: "Denmark - DK" },
  { code: "46", name: "Sweden - SE" },
  { code: "47", name: "Norway - NO" },
  { code: "48", name: "Poland - PL" },
  { code: "49", name: "Germany - DE" },
  { code: "51", name: "Peru - PE" },
  { code: "52", name: "Mexico - MX" },
  { code: "53", name: "Cuba - CU" },
  { code: "54", name: "Argentina - AR" },
  { code: "55", name: "Brazil - BR" },
  { code: "56", name: "Chile - CL" },
  { code: "57", name: "Colombia - CO" },
  { code: "58", name: "Venezuela - VE" },
  { code: "60", name: "Malaysia - MY" },
  { code: "61", name: "Australia - AU" },
  { code: "62", name: "Indonesia - ID" },
  { code: "63", name: "Philippines - PH" },
  { code: "64", name: "New Zealand - NZ" },
  { code: "65", name: "Singapore - SG" },
  { code: "66", name: "Thailand - TH" },
  { code: "81", name: "Japan - JP" },
  { code: "82", name: "South Korea - KR" },
  { code: "84", name: "Vietnam - VN" },
  { code: "86", name: "China - CN" },
  { code: "90", name: "Turkey - TR" },
  { code: "91", name: "India - IN" },
  { code: "92", name: "Pakistan - PK" },
  { code: "93", name: "Afghanistan - AF" },
  { code: "94", name: "Sri Lanka - LK" },
  { code: "95", name: "Myanmar - MM" },
  { code: "98", name: "Iran - IR" },
  { code: "211", name: "South Sudan - SS" },
  { code: "212", name: "Morocco - MA" },
  { code: "213", name: "Algeria - DZ" },
  { code: "216", name: "Tunisia - TN" },
  { code: "218", name: "Libya - LY" },
  { code: "220", name: "Gambia - GM" },
  { code: "221", name: "Senegal - SN" },
  { code: "222", name: "Mauritania - MR" },
  { code: "223", name: "Mali - ML" },
  { code: "224", name: "Guinea - GN" },
  { code: "225", name: "Ivory Coast - CI" },
  { code: "226", name: "Burkina Faso - BF" },
  { code: "227", name: "Niger - NE" },
  { code: "228", name: "Togo - TG" },
  { code: "229", name: "Benin - BJ" },
  { code: "230", name: "Mauritius - MU" },
  { code: "231", name: "Liberia - LR" },
  { code: "232", name: "Sierra Leone - SL" },
  { code: "233", name: "Ghana - GH" },
  { code: "234", name: "Nigeria - NG" },
  { code: "235", name: "Chad - TD" },
  { code: "236", name: "Central African Republic - CF" },
  { code: "237", name: "Cameroon - CM" },
  { code: "238", name: "Cape Verde - CV" },
  { code: "239", name: "Sao Tome and Principe - ST" },
  { code: "240", name: "Equatorial Guinea - GQ" },
  { code: "241", name: "Gabon - GA" },
  { code: "242", name: "Congo - Brazzaville - CG" },
  { code: "243", name: "Congo - Kinshasa - CD" },
  { code: "244", name: "Angola - AO" },
  { code: "245", name: "Guinea-Bissau - GW" },
  { code: "246", name: "British Indian Ocean Territory - IO" },
  { code: "248", name: "Seychelles - SC" },
  { code: "249", name: "Sudan - SD" },
  { code: "250", name: "Rwanda - RW" },
  { code: "251", name: "Ethiopia - ET" },
  { code: "252", name: "Somalia - SO" },
  { code: "253", name: "Djibouti - DJ" },
  { code: "254", name: "Kenya - KE" },
  { code: "255", name: "Tanzania - TZ" },
];

const splitPhoneWithCountryCode = (value, countryCodes = DEFAULT_COUNTRY_CODES) => {
  if (!value) return { countryCode: countryCodes[0]?.code || "", phone: "" };
  const sorted = [...countryCodes].sort((a, b) => b.code.length - a.code.length);
  const match = sorted.find((c) => value.startsWith(c.code));
  return match
    ? { countryCode: match.code, phone: value.slice(match.code.length) }
    : { countryCode: "", phone: value };
};

const isFieldFilled = (field, value) => {
  if (field.controlType === "file") {
    return Array.isArray(value) && value.length > 0;
  }

  if (field.controlType === "Phone") {
    const { phone } = splitPhoneWithCountryCode(
      (value ?? "").toString(),
      field.countryCodes || DEFAULT_COUNTRY_CODES
    );
    return phone.trim().length > 0; // country code alone doesn't count
  }

  return (value ?? "").toString().trim().length > 0;
};

const getFieldOptions = (field) =>
  (field.options || []).map((opt) =>
    typeof opt === "string"
      ? { value: opt, label: opt }
      : { value: opt.value, label: opt.label ?? opt.value }
  );

const isPercentageField = (field) => field?.controlType === "Percentage";

// UI value (6) -> payload value (0.06)
const percentToPayload = (value) => {
  if (value === "" || value === null || value === undefined) return value;
  const n = Number(value);
  return Number.isNaN(n) ? value : Number((n / 100).toFixed(10));
};

// datasource value (0.06) -> UI value (6)
const percentFromPayload = (value) => {
  const n = parseFloat(value);
  return Number.isNaN(n) ? "" : Number((n * 100).toFixed(10));
};

// Converts a raw datasource value into the value the matching form control expects
const normalizeInitialValue = (field, raw) => {
  if (field.controlType === "file") return [];
  if (raw === undefined || raw === null) return "";

  const options = getFieldOptions(field);

  // objects like { id, name } -> id; primitives pass through
  const toKey = (v) => {
    if (v === undefined || v === null) return "";
    if (typeof v === "object") return v.id ?? v.value ?? v.name ?? "";
    return v;
  };

  // match against option value OR label so either form from the datasource works
  const resolveOption = (v) => {
    const k = toKey(v);
    const hit = options.find(
      (o) => String(o.value) === String(k) || String(o.label) === String(k)
    );
    return hit ? hit.value : k;
  };

  switch (field.controlType) {
    case "Multi Checkbox":
    case "Multi Picklist": {
      const list = Array.isArray(raw)
        ? raw
        : String(raw).split(";").map((s) => s.trim()).filter(Boolean);
      return list.map((v) => String(resolveOption(v))).join(";");
    }

    case "Individual lookup":
    case "List Lookup":
      return String(resolveOption(raw));

    case "Option":
    case "Picklist":
      return resolveOption(raw);

    case "Boolean":
      if (typeof raw === "boolean") return raw;
      if (String(raw).toLowerCase() === "true") return true;
      if (String(raw).toLowerCase() === "false") return false;
      return "";

    case "Percentage":
      return percentFromPayload(toKey(raw));

    case "Number":
    case "Amount":
    case "Double": {
      const n = parseFloat(toKey(raw));
      return Number.isNaN(n) ? "" : n;
    }

    case "Date":
      return String(raw).slice(0, 10);

    case "Date/Time":
      return String(raw).slice(0, 16); // yyyy-MM-ddTHH:mm for datetime-local

    default:
      if (options.length > 0) return resolveOption(raw);
      return String(typeof raw === "object" ? toKey(raw) : raw);
  }
};

// Initial draft for one datasource row (only for Update Record)
const getInitialRowDraft = (m, row) => {
  if (m?.actionName !== "Update Record" || !row) return {};
  const draft = {};
  (m.formFields || []).forEach((field) => {
    const raw = row[field.name];
    if (raw === undefined || raw === null) return;
    const v = normalizeInitialValue(field, raw);
    if (v !== "" && !(Array.isArray(v) && v.length === 0)) draft[field.name] = v;
  });
  return draft;
};

// Read-only datasource columns. For Update Record, fields that are editable
// in the table are hidden here so they are not shown twice.
const getReadColumns = (m, tableData) => {
  const hideEditable = m?.actionName === "Update Record";
  const editableNames = new Set((m?.formFields || []).map((f) => f.name));
  return Object.keys(tableData?.[0] || {})
    .filter(
      (c) => c.toLowerCase() !== "id" && !(hideEditable && editableNames.has(c))
    )
    .slice(0, 4);
};

const isRequiredField = (field) => {
  const v = field?.isrequired;
  return v === true || v === "true" || v === 1 || v === "1";
};

const isValidEmail = (value) => {
  if (!value?.trim()) return false;

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
};

const FieldWrapper = ({ label, required, filled, children, textColor, fontFamily }) => (
  <Box sx={{ width: "100%" }}>
    <Typography
      sx={{
        fontSize: 11.5,
        fontWeight: 700,
        color: filled ? textColor : "#9B978C",
        fontFamily,
        mb: 0.5,
        letterSpacing: 0.2,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {label}
      {required && (
        <Box component="span" sx={{ color: "#D64545" }}>
          *
        </Box>
      )}
    </Typography>
    {children}
  </Box>
);

const fieldBoxSx = (accent, filled) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: filled ? `${accent}0D` : "#fff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: filled ? `${accent}55` : "#E3E1DA",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: `${accent}AA`,
    },
    "&.Mui-focused": {
      bgcolor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: accent,
        borderWidth: "1.5px",
      },
    },
  },
});

// Shared z-index so dropdowns render above the Dialog (zIndex 1400)
const DROPDOWN_Z_INDEX = 1500;

const selectMenuProps = { sx: { zIndex: DROPDOWN_Z_INDEX } };
const autocompletePopperProps = { sx: { zIndex: DROPDOWN_Z_INDEX } };

const renderField = (field, value, onChange, opts = {}) => {
  const {
    disabled,
    accent,
    textColor,
    fontFamily,
    hideLabel = false, // table cells: the column header already shows the label
    compact = false, // smaller font for table cells
    idPrefix, // makes DOM ids unique per row
  } = opts;

  const fieldId = idPrefix ? `${idPrefix}-${field.name}` : `value-${field.name}`;

  const labelText =
    field.label
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ") ?? "";

  const filled = isFieldFilled(field, value);
  const wrap = (children) =>
    hideLabel ? (
      children
    ) : (
      <FieldWrapper
        label={labelText}
        filled={filled}
        required={isRequiredField(field)}
        textColor={textColor}
        fontFamily={fontFamily}
      >
        {children}
      </FieldWrapper>
    );

  const commonInputProps = {
    style: { fontFamily, color: textColor, fontSize: compact ? 12 : 13 },
  };

  switch (field.controlType) {
    case "Multi Checkbox":
    case "Multi Picklist": {
      const options = getFieldOptions(field);
      const normalizedValues = Array.isArray(value)
        ? value.map(String)
        : typeof value === "string" && value.trim() !== ""
          ? value.split(";").map((v) => v.trim()).filter(Boolean)
          : [];

      const selected = normalizedValues.map(
        (val) => options.find((o) => String(o.value) === val) || { value: val, label: val }
      );

      return wrap(
        <Autocomplete
          multiple
          disabled={disabled}
          disableCloseOnSelect
          id={fieldId}
          options={options}
          value={selected}
          getOptionLabel={(option) => option.label ?? ""}
          isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
          onChange={(e, newValue) => onChange(newValue.map((v) => String(v.value)).join(";"))}
          componentsProps={{ popper: autocompletePopperProps }}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option.value}
                label={option.label}
                size="small"
                sx={{
                  bgcolor: accent,
                  color: "#fff",
                  fontFamily,
                  fontSize: 12,
                  fontWeight: 600,
                  "& .MuiChip-deleteIcon": { color: "#ffffffcc", "&:hover": { color: "#fff" } },
                }}
              />
            ))
          }
          renderOption={(props, option) => {
            const { key, ...optionProps } = props;
            const isChecked = normalizedValues.includes(String(option.value));
            return (
              <li key={key} {...optionProps}>
                <Checkbox
                  size="small"
                  checked={isChecked}
                  sx={{ mr: 1, "&.Mui-checked": { color: accent } }}
                />
                {option.label}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              placeholder={field.label}
              InputProps={{ ...params.InputProps, style: commonInputProps.style }}
              sx={fieldBoxSx(accent, filled)}
            />
          )}
        />
      );
    }

    case "Individual lookup":
    case "List Lookup": {
      const options = getFieldOptions(field);
      return wrap(
        <Autocomplete
          id={fieldId}
          disabled={disabled}
          options={options}
          getOptionLabel={(option) => option.label ?? ""}
          isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
          value={options.find((o) => String(o.value) === String(value)) || null}
          onChange={(e, newValue) => onChange(newValue ? String(newValue.value) : "")}
          componentsProps={{ popper: autocompletePopperProps }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              fullWidth
              placeholder="Select..."
              InputProps={{ ...params.InputProps, style: commonInputProps.style }}
              sx={fieldBoxSx(accent, filled)}
            />
          )}
          noOptionsText="No values available"
        />
      );
    }

    case "Boolean":
      return wrap(
        <FormControl fullWidth size="small" sx={fieldBoxSx(accent, filled)}>
          <Select
            disabled={disabled}
            id={fieldId}
            value={value ?? ""}
            displayEmpty
            MenuProps={selectMenuProps}
            style={commonInputProps.style}
            onChange={(e) => onChange(e.target.value)}
            renderValue={(v) =>
              v === "" ? <span style={{ color: "#9B978C" }}>{field.label}</span> : String(v)
            }
          >
            <MenuItem value={true} sx={{ "&.Mui-selected": { bgcolor: `${accent}1A` } }}>
              True
            </MenuItem>
            <MenuItem value={false} sx={{ "&.Mui-selected": { bgcolor: `${accent}1A` } }}>
              False
            </MenuItem>
          </Select>
        </FormControl>
      );

    case "Option":
    case "Picklist": {
      const options = getFieldOptions(field);
      return wrap(
        <FormControl fullWidth size="small" sx={fieldBoxSx(accent, filled)}>
          <Select
            disabled={disabled}
            id={fieldId}
            value={value ?? ""}
            displayEmpty
            MenuProps={selectMenuProps}
            style={commonInputProps.style}
            onChange={(e) => onChange(e.target.value)}
            renderValue={(v) => {
              const opt = options.find((o) => o.value === v);
              return v === "" || !opt ? (
                <span style={{ color: "#9B978C" }}>{field.label}</span>
              ) : (
                opt.label
              );
            }}
          >
            {options.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ "&.Mui-selected": { bgcolor: `${accent}1A` } }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    case "Email": {
      const emailValue = value ?? "";
      const hasValue = emailValue.trim().length > 0;
      const emailValid = !hasValue || isValidEmail(emailValue);

      return wrap(
        <TextField
          id={fieldId}
          name={field.name}
          value={emailValue}
          type="email"
          placeholder={field.label}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          error={hasValue && !emailValid}
          helperText={hasValue && !emailValid ? "Please enter a valid email address" : ""}
          InputProps={{
            style: commonInputProps.style,
            endAdornment: hasValue && emailValid && (
              <InputAdornment position="end">
                <CheckCircleIcon sx={{ fontSize: 16, color: accent }} />
              </InputAdornment>
            ),
          }}
          sx={fieldBoxSx(accent, filled)}
        />
      );
    }

    case "Number":
    case "Amount":
    case "Percentage":
    case "Double":
      return wrap(
        <TextField
          id={fieldId}
          name={field.name}
          value={value === 0 || value ? value : ""}
          type="number"
          placeholder={field.label}
          onChange={(e) =>
            onChange(e.target.value === "" ? "" : parseFloat(e.target.value) || 0)
          }
          variant="outlined"
          size="small"
          fullWidth
          onKeyDown={(e) => {
            // no negative numbers / exponent notation
            if (e.key === "-" || e.key === "e") {
              e.preventDefault();
            }
          }}
          disabled={disabled}
          inputProps={{ min: 0 }}
          InputProps={{ style: commonInputProps.style }}
          sx={fieldBoxSx(accent, filled)}
        />
      );

    case "Date":
      return wrap(
        <TextField
          id={fieldId}
          name={field.name}
          value={value ?? ""}
          type="date"
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          InputProps={{ style: commonInputProps.style }}
          sx={fieldBoxSx(accent, filled)}
        />
      );

    case "Date/Time":
      return wrap(
        <TextField
          id={fieldId}
          name={field.name}
          value={value ?? ""}
          type="datetime-local"
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          InputProps={{ style: commonInputProps.style }}
          sx={fieldBoxSx(accent, filled)}
        />
      );

    case "Phone": {
      const countryCodes = field.countryCodes || DEFAULT_COUNTRY_CODES;
      const { countryCode, phone } = splitPhoneWithCountryCode(value, countryCodes);

      return wrap(
        <TextField
          id={fieldId}
          value={phone || ""}
          type="tel"
          placeholder={field.label}
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          onChange={(e) => {
            const newPhone = e.target.value.replace(/[^\d]/g, "");
            onChange(newPhone ? `${countryCode}${newPhone}` : "");
          }}
          InputProps={{
            style: commonInputProps.style,
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{ pr: 1, mr: 0.5, borderRight: `1px solid ${accent}33` }}
              >
                <Autocomplete
                  disabled={disabled}
                  disableClearable
                  size="small"
                  sx={{ width: 40 }}
                  options={countryCodes}
                  value={countryCodes.find((c) => c.code === countryCode) || countryCodes[0]}
                  getOptionLabel={(option) => `+${option.code}`}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {option.code} — {option.name}
                    </li>
                  )}
                  onChange={(e, newValue) => {
                    const newCode = newValue?.code || "";
                    onChange(newCode ? `${newCode}${phone}` : phone);
                  }}
                  componentsProps={{
                    popper: {
                      style: { width: 260, zIndex: DROPDOWN_Z_INDEX },
                      placement: "bottom-start",
                    },
                  }}
                  ListboxProps={{ style: { fontSize: 13 } }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        style: { color: accent, fontWeight: 700, fontSize: 13 },
                      }}
                    />
                  )}
                />
              </InputAdornment>
            ),
          }}
          sx={fieldBoxSx(accent, filled)}
        />
      );
    }

    default: {
      const options = getFieldOptions(field);
      const isNumberField = /number|amount|percentage/i.test(field.controlType || "");
      const isDateField = /date/i.test(field.controlType || "");

      if (options.length > 0) {
        return wrap(
          <FormControl fullWidth size="small" sx={fieldBoxSx(accent, filled)}>
            <Select
              disabled={disabled}
              id={fieldId}
              value={value ?? ""}
              displayEmpty
              MenuProps={selectMenuProps}
              style={commonInputProps.style}
              onChange={(e) => onChange(e.target.value)}
              renderValue={(v) => {
                const opt = options.find((o) => o.value === v);
                return v === "" || !opt ? (
                  <span style={{ color: "#9B978C" }}>Select...</span>
                ) : (
                  opt.label
                );
              }}
            >
              {options.map((opt) => (
                <MenuItem
                  key={opt.value}
                  value={opt.value}
                  sx={{ "&.Mui-selected": { bgcolor: `${accent}1A` } }}
                >
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }

      return wrap(
        <TextField
          id={fieldId}
          placeholder={field.label}
          name={field.name}
          value={value ?? ""}
          type={isNumberField ? "number" : isDateField ? "date" : "text"}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          InputProps={{ style: commonInputProps.style }}
          sx={fieldBoxSx(accent, filled)}
        />
      );
    }
  }
};

// ---- Display Table helpers ----
const TABLE_READ_COL_PX = 110;
const TABLE_ACTION_COL_PX = 56;

// Pixel width per input column, based on how much room the control needs
const getTableInputWidth = (field) => {
  switch (field.controlType) {
    case "Multi Checkbox":
    case "Multi Picklist":
      return 220;
    case "Phone":
      return 100;
    case "Date/Time":
    case "Email":
    case "Text":
    case "TextArea":
      return 150;
    case "Amount":
    case "Number":
    case "Double":
    case "Percentage":
      return 70;
    default:
      return 70;
  }
};

// Human-readable value for the batch summary (labels instead of ids, file names instead of File objects)
const formatDraftValue = (field, value) => {
  if (Array.isArray(value)) return value.map((f) => f?.name ?? String(f)).join(", ");
  if (value === undefined || value === null) return "";
  const options = getFieldOptions(field);
  if (options.length) {
    return String(value)
      .split(";")
      .map((v) => options.find((o) => String(o.value) === v.trim())?.label ?? v)
      .join(", ");
  }
  return String(value);
};

// Compact file picker for table cells (renderField has no "file" case; forms handle it separately)
function TableFileCell({ id, value, disabled, onChange, accent, accentDark, fontFamily }) {
  return (
    <>
      <input
        id={id}
        type="file"
        hidden
        disabled={disabled}
        onChange={(e) => onChange(e.target.files?.[0] ? [e.target.files[0]] : [])}
      />
      <label htmlFor={id} style={{ display: "block" }}>
        <Button
          component="span"
          variant="outlined"
          size="small"
          fullWidth
          disabled={disabled}
          startIcon={<UploadFileOutlinedIcon sx={{ fontSize: 14 }} />}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            fontSize: 12,
            fontFamily,
            minHeight: 32,
            justifyContent: "flex-start",
            color: accent,
            borderColor: accent,
            "&:hover": { borderColor: accentDark, color: accentDark, backgroundColor: "transparent" },
            "&.Mui-disabled": { borderColor: "#D9D6CC", color: "#B7B4AC" },
          }}
        >
          <Box
            component="span"
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {value?.[0]?.name || "Choose file"}
          </Box>
        </Button>
      </label>
    </>
  );
}

function ActionFormCard({
  message,
  active,
  draft,
  onFieldChange,
  onSubmit,
  sending,
  accent,
  accentDark,
  textColor,
  fontFamily,
}) {
  const fields = message.formFields || [];
  const requiredFields = fields.filter(isRequiredField);
  const filledRequiredCount = requiredFields.filter((f) =>
    isFieldFilled(f, draft[f.name])
  ).length;
  const totalCount = fields.length;
  const complete = requiredFields.length === filledRequiredCount;
  const hasFields = totalCount > 0;
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);

  const cardSx = {
    width: "100%",
    maxWidth: "90%",
    borderRadius: "14px",
    border: "1px solid #ECEAE4",
    bgcolor: "#fff",
    overflow: "hidden",
  };

  const isUploadDocument = message.actionName === "Upload Document";

  const uploadField = isUploadDocument ? fields[0] : null;
  const uploadValue = uploadField ? (draft[uploadField.name] ?? []) : [];
  const uploadFilled = uploadField ? isFieldFilled(uploadField, uploadValue) : false;

  const handleSubmitClick = () => {
    if (isUploadDocument) {
      if (!uploadFilled) {
        setAttemptedSubmit(true);
        return;
      }
      setAttemptedSubmit(false);
      onSubmit();
      return;
    }
    if (!complete) {
      setAttemptedSubmit(true);
      return;
    }
    setAttemptedSubmit(false);
    onSubmit();
  };

  const primaryBtnSx = {
    textTransform: "none",
    borderRadius: "10px",
    fontSize: 13,
    fontWeight: 700,
    bgcolor: accent,
    fontFamily,
    color: "#fff",
    py: 1,
    "&:hover": { bgcolor: accentDark },
    "&.Mui-disabled": { bgcolor: "#EDEBE5", color: "#B7B4AC" },
  };

  return (
    <Paper elevation={0} sx={{ ...cardSx, boxShadow: "0 2px 10px rgba(27,27,31,0.06)" }}>
      {hasFields ? (
        isUploadDocument ? (
          (() => {
            const field = fields[0];
            const rawValue = draft[field.name];
            const value = rawValue ?? [];

            return (
              <>
                <Box sx={{ px: 1.75, py: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
                  <input
                    id={`${message.id}-${field.name}`}
                    type="file"
                    hidden
                    disabled={!active || sending}
                    onChange={(e) =>
                      onFieldChange(field.name, e.target.files?.[0] ? [e.target.files[0]] : [])
                    }
                  />

                  {/* Upload Icon */}
                  <label htmlFor={`${message.id}-${field.name}`}>
                    <Tooltip title="Choose file">
                      <span>
                        <IconButton
                          component="span"
                          disabled={!active || sending}
                          sx={{
                            border: `1px solid ${accent}`,
                            borderRadius: "8px",
                            color: accent,
                            width: 34,
                            height: 34,
                            flexShrink: 0,
                            "&:hover": {
                              borderColor: accentDark,
                              color: accentDark,
                              backgroundColor: "transparent",
                            },
                            "&.Mui-disabled": { borderColor: "#D9D6CC", color: "#B7B4AC" },
                          }}
                        >
                          <UploadFileOutlinedIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </label>

                  {/* File name */}
                  <Typography
                    sx={{
                      fontSize: 11.5,
                      color: textColor,
                      fontFamily,
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {value?.[0]?.name || "Choose file"}
                  </Typography>

                  {/* Small Upload button */}
                  <Button
                    disabled={sending || !active}
                    onClick={handleSubmitClick}
                    size="small"
                    sx={{
                      minWidth: "auto",
                      px: 1.5,
                      py: 0.5,
                      height: 32,
                      textTransform: "none",
                      borderRadius: "8px",
                      fontSize: 12,
                      fontWeight: 700,
                      bgcolor: accent,
                      fontFamily,
                      color: "#fff",
                      flexShrink: 0,
                      "&:hover": { bgcolor: accentDark },
                      "&.Mui-disabled": { bgcolor: "#EDEBE5", color: "#B7B4AC" },
                    }}
                  >
                    {active ? "submit" : "submitted"}
                  </Button>
                </Box>
                {attemptedSubmit && !uploadFilled && (
                  <Typography sx={{ fontSize: 11, color: "#D64545", fontFamily, ml: "42px" }}>
                    Please choose a file
                  </Typography>
                )}
              </>
            );
          })()
        ) : (
          <>
            <Box sx={{ px: 1.75, py: 1.5, display: "flex", flexDirection: "column", gap: 1.25 }}>
              {fields.map((field) => {
                const rawValue = draft[field.name];
                const value = rawValue ?? (field.controlType === "file" ? [] : "");

                return (
                  <Box key={`${message.id}-${field.name}`}>
                    {field.controlType === "file" ? (
                      <>
                        <input
                          id={`${message.id}-${field.name}`}
                          type="file"
                          hidden
                          disabled={!active || sending}
                          onChange={(e) =>
                            onFieldChange(
                              field.name,
                              e.target.files?.[0] ? [e.target.files[0]] : []
                            )
                          }
                        />

                        <label htmlFor={`${message.id}-${field.name}`}>
                          <Button
                            component="span"
                            variant="outlined"
                            size="small"
                            disabled={!active || sending}
                            sx={{
                              textTransform: "none",
                              borderRadius: "8px",
                              fontSize: 12,
                              fontWeight: 600,
                              fontFamily,
                              minHeight: 32,
                              px: 1.5,
                              py: 0.5,
                              color: accent,
                              borderColor: accent,
                              "&:hover": {
                                borderColor: accentDark,
                                color: accentDark,
                                backgroundColor: "transparent",
                              },
                              "&.Mui-disabled": { borderColor: "#D9D6CC", color: "#B7B4AC" },
                            }}
                          >
                            Choose File
                          </Button>
                        </label>

                        {value?.[0] && (
                          <Typography
                            sx={{
                              mt: 0.5,
                              fontSize: 11,
                              color: "#77746A",
                              fontFamily,
                              wordBreak: "break-all",
                            }}
                          >
                            {value[0].name}
                          </Typography>
                        )}
                      </>
                    ) : (
                      renderField(field, value, (val) => onFieldChange(field.name, val), {
                        disabled: !active || sending,
                        accent,
                        textColor,
                        fontFamily,
                      })
                    )}
                  </Box>
                );
              })}
            </Box>

            <Box sx={{ px: 1.75, pb: 1.5 }}>
              <Button
                fullWidth
                disabled={sending || !complete || !active}
                onClick={onSubmit}
                sx={primaryBtnSx}
              >
                {active ? "Save" : "Saved"}
              </Button>
            </Box>
          </>
        )
      ) : (
        <>
          <Box
            sx={{
              px: 1.75,
              py: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              gap: 0.5,
            }}
          >
            <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: "#9B978C", fontFamily }}>
              No additional details needed
            </Typography>
          </Box>

          <Box sx={{ px: 1.75, pb: 1.5 }}>
            <Button fullWidth disabled={sending || !active} onClick={onSubmit} sx={primaryBtnSx}>
              {active ? "Continue" : "Completed"}
            </Button>
          </Box>
        </>
      )}
    </Paper>
  );
}

// ---- Panel sizing constant ----
const PANEL_WIDTH = 350;

const FORMAT_TO_TYPE = {
  "Input Text": "inputtext",
  "Input Number": "inputnumber",
  "Input Option": "inputoption",
  "Input Picklist": "picklist",
  "Input Button": "button",
  "Input Date": "inputdate",
  "Input Checkbox": "checkbox",
  "Display HTML": "html",
  "Display Picklist": "displaypicklist",
  "Display Text": "text",
  "Input Phone": "inputphone",
  "Input Email": "inputemail",
  "Display Table": "displaytable",
  "Display Form": "displayform",
};

const OPTION_TYPES = new Set([
  "inputoption",
  "picklist",
  "button",
  "checkbox",
  "displaypicklist",
  "displaylist",
]);

// Types where the user picks from options rather than free-typing
const CHOICE_TYPES = new Set(["inputoption", "picklist", "button", "checkbox", "displaypicklist"]);

const ACTION_PAYLOAD_KEY = {
  "Create Record": "createpayload",
  "Search Single Record": "searchrecord",
  "Get Single Record": "getsinglerecord",
  "Upload Document": "uploaddocument",
  "Send SMS": "sendsms",
  "Send Whatsapp": "sendwhatsapp",
  "Send Email": "sendemail",
  "Update Record": "updatepayload",
};

const SMS_LIKE_ACTIONS = new Set(["Send SMS", "Send Whatsapp", "Upload Document", "Send Email"]);

const getPayloadKey = (actionName) => {
  if (ACTION_PAYLOAD_KEY[actionName]) return ACTION_PAYLOAD_KEY[actionName];
  return (actionName || "").toLowerCase().replace(/\s+/g, "");
};

const isUserFacingField = (cfg) => cfg?.type === "userinput" || cfg?.type === "userdefined";

const prettifyFieldLabel = (name) =>
  name ? name.charAt(0).toUpperCase() + name.slice(1) : name;

const getOptionLabel = (option) =>
  typeof option === "string" ? option : option?.label ?? "";

const getOptionKey = (option) =>
  typeof option === "string" ? option : JSON.stringify(option?.value ?? option?.label ?? "");

const getOptionValue = (option) =>
  typeof option === "string" ? undefined : option?.value;

const formatDateForDisplay = (isoLike) => {
  if (!isoLike) return isoLike;
  const [year, month, day] = isoLike.split("-");
  if (!year || !month || !day) return isoLike;
  return `${day}/${month}/${year}`;
};

const fileToBase64 = (file) =>
  new Promise((resolve) => {
    if (!file) {
      resolve("");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result || "");
    };
    reader.onerror = () => resolve("");
    reader.readAsDataURL(file);
  });

const filesToPayload = async (files) =>
  (await Promise.all((files || []).map((file) => fileToBase64(file))))[0];

const buildSmsLikeFields = (cfg) => {
  const fields = cfg?.fields || {};

  return Object.entries(fields).reduce((acc, [fieldName, fieldCfg]) => {
    acc[fieldName] = {
      type: fieldCfg?.type,
      value: fieldCfg?.type === "fromprevstep" ? (fieldCfg?.value ?? null) : fieldCfg?.value,
    };
    return acc;
  }, {});
};

// Turns any cell value into plain text for CSV (objects -> name/label, arrays -> joined)
const csvCellValue = (value) => {
  if (value === null || value === undefined) return "-";

  if (Array.isArray(value)) {
    return value.map(csvCellValue).filter(Boolean).join("; ");
  }

  if (typeof value === "object") {
    return String(value.name ?? value.label ?? value.lable ?? value.value ?? "-");
  }

  return String(value);
};

const downloadCSV = (tableData, columns) => {
  if (!tableData?.length) return;

  const csvContent = [
    columns.join(","),
    ...tableData.map((row) =>
      columns
        .map((column) => {
          const value = csvCellValue(row[column]);
          return `"${value.replace(/"/g, '""')}"`;
        })
        .join(",")
    ),
  ].join("\n");

  // "\uFEFF" (BOM) makes Excel read UTF-8 correctly
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "display_table.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};

const getValue = (value) => {
  if (!value) return "-";

  // if array
  if (Array.isArray(value)) {
    return value.map((item) => item?.name).join(", ") || "-";
  }

  // if object
  if (typeof value === "object") {
    return value?.name || "-";
  }

  // if string or number
  return value;
};

export default function FloatingChatButton() {
  // Chat panel is always visible now (no floating button)
  const [open, setOpen] = useState(true);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [textInputDisabled, setTextInputDisabled] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: "welcome",
      role: "bot",
      type: "text",
      text: "Welcome! How can I help you today?",
    },
  ]);
  const [journeyId, setJourneyId] = useState("");
  const [intentSelectionLocked, setIntentSelectionLocked] = useState(false);
  const inputRef = useRef(null);
  const bodyEndRef = useRef(null);
  const [executionGuid, setExecutionGuid] = useState(null);
  const [selectedExecution, setSelectedExecution] = useState(null);
  const [selectedIntentId, setSelectedIntentId] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggingIn, setLoggingIn] = useState(false);
  // Refs update synchronously, so they reliably block duplicate login calls
  const loginDoneRef = useRef(false); // true once login succeeded
  const loginInFlightRef = useRef(false); // true while the login request is running

  const [answeredOptions, setAnsweredOptions] = useState({});
  const [checkboxDraft, setCheckboxDraft] = useState({});
  const [formDrafts, setFormDrafts] = useState({});
  const [stepHistory, setStepHistory] = useState({});
  const [tableDrafts, setTableDrafts] = useState({});
  const [tableBatch, setTableBatch] = useState({});
  // Update Record: rows the user has switched into edit mode  { [messageId]: { [rowId]: true } }
  const [editingRows, setEditingRows] = useState({});
  const [footerCountryCode, setFooterCountryCode] = useState("91"); // default, change as needed

  // id of the message whose Display Table is currently open in the popup (null = closed)
  const [tablePopupId, setTablePopupId] = useState(null);
  const [tableSearch, setTableSearch] = useState("");

  // start with an empty search every time the popup opens or closes
  useEffect(() => {
    setTableSearch("");
  }, [tablePopupId]);

  // Cache of multivalues rows fetched per action/datasource "object" id.
  // Used to build dropdown/lookup/checkbox options for form fields.
  const [multivaluesByObject, setMultivaluesByObject] = useState({});
  const multivaluesByObjectRef = useRef({});

  const isMobile = useMediaQuery("(max-width:768px)");

  const primaryColor = COLORS.primaryColor;
  const fontFamilyall = fontFamilyAll;
  const PageBackgroundColor = COLORS.whiteColor;
  const secondaryColor = COLORS.secondaryColor;
  const TextColor = COLORS.blackColor;
  const ACCENT = secondaryColor;
  const ACCENT_DARK = secondaryColor;

  const animatedIdsRef = useRef(new Set());

  // Resolves journeyId — which "system interface" this widget should treat
  // as the starting point (web vs mobile).
  const fetchMultivalues = async () => {
    try {
      const deviceType = getDeviceType();

      const res = await GetRecordApi({
        tables: ["multivalues"],
        fields: ["*"],
        pagination: { page: null, itemsperpage: null },
        joins: [],
        group_by: [],
        order_by: [],
        where: [
          {
            column: "objectfieldapiname",
            operator: "=",
            value: "journeystartsfrom",
          },
        ],
      });

      const targetApiName = "chatbot";

      const journeyID = res?.data?.find((item) => item.apiname === targetApiName)?.id;

      setJourneyId(journeyID);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetches (and caches) all multivalues rows scoped to a given action's
  // target object id, e.g. ds?.object?.id or apiaction?.object?.id.
  const fetchMultivaluesForObject = async (objectId, businessid) => {
    if (objectId == null) return [];

    if (multivaluesByObjectRef.current[objectId]) {
      return multivaluesByObjectRef.current[objectId];
    }

    try {
      const res = await GetRecordApi({
        tables: ["multivalues"],
        fields: ["*"],
        pagination: { page: null, itemsperpage: null },
        joins: [],
        group_by: [],
        order_by: [],
        where: [
          { column: "object", operator: "=", value: objectId },
          ...(businessid
            ? [{ column: "businessprocess", operator: "=", value: businessid }]
            : []),
        ],
      });

      const data = res?.data || [];
      multivaluesByObjectRef.current[objectId] = data;
      setMultivaluesByObject((prev) => ({ ...prev, [objectId]: data }));
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // Narrows a cached multivalues list down to one field's options list,
  // shaped as [{ value, label }] for renderField's Picklist/Lookup/etc cases.
  const buildOptionsFromMultivalues = (multivaluesForObject, fieldApiName) =>
    (multivaluesForObject || [])
      .filter((item) => item.objectfieldapiname === fieldApiName)
      .map((item) => ({
        value: item.id,
        label: item.businessprocess
          ? `${item.businessprocess.name} - ${item.lable}`
          : item.lable,
      }));

  // Login runs at most once: the refs block repeat calls (re-renders,
  // StrictMode double-effects). A failed login leaves them false so it can retry.
  // Credentials and base URL come from the iframe URL (see Util/apiConfig.js)
  const performLogin = async () => {
    // if (loginDoneRef.current || loginInFlightRef.current) return;

    

    // loginInFlightRef.current = true;
    // setLoggingIn(true);

    try {
      const response = await LoginAPI({
        uid:"0023006400690038007200030055001F004A001F0022003F0027007600260043005800540002005400760033002F006D0026000000570051000F005200360064006D00250033000E0045000F0052000D0021007B006C003100650047005D00590007005E0055000400140052000D002F00200020007200300016000B0011005F000B003C00030009004A003700150045005D003C0035004F005900450011K3y!9Kye10"
      });

      if (response?.message === "Mica logged in successfully") {
        const expirationTime = new Date(new Date().getTime() + 24 * 3600 * 1000);

        // Cookies.set(
        //   "lkmhbdsfsxasdweioisndi",
        //   response?.data?.isadmin ? "nlkjxftvyiukjnkjn" : null,
        //   { expires: expirationTime, secure: true, sameSite: "None" }
        // );

        Cookies.set("jknfdiuniosad", response?.id ? "njkiasndpoi" : "jhbsdohb", {
          expires: expirationTime,
          secure: true,
          sameSite: "None",
        });

        Cookies.set("username", response?.username, {
          expires: expirationTime,
          secure: true,
          sameSite: "None",
        });

        // // Latch: never call login again
        // loginDoneRef.current = true;
        // setIsLoggedIn(true);

        // Fetch journey only after successful login (the only place it runs)
        await fetchMultivalues();
      }
    } catch (err) {
      console.log("Login error:", err);
    } finally {
      // loginInFlightRef.current = false;
      // setLoggingIn(false);
    }
  };

  // Log in once, when the component is first rendered
  useEffect(() => {
    performLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (open) {
      const t = setTimeout(() => inputRef.current?.focus(), 220);
      return () => clearTimeout(t);
    }
  }, [open]);

  // Auto-scroll to the latest message whenever the list changes
  useEffect(() => {
    bodyEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, sending]);

  useEffect(() => {
    if (open && !sending && !textInputDisabled) {
      inputRef.current?.focus();
    }
  }, [open, sending, textInputDisabled]);

  const scrollToBottom = () => {
    bodyEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const resolveFieldDisplay = (val) => {
    if (val == null) return "";
    if (typeof val === "object") {
      return val.name ?? val.label ?? val.value ?? "";
    }
    if (Array.isArray(val)) {
      return val.map((item) => item?.name).join(",") || "";
    }
    return val;
  };

  const toArray = (val) => {
    if (val == null) return [];
    return Array.isArray(val) ? val : [val];
  };

  const buildOptionsFromValueList = (valuelist) =>
    (valuelist || []).map((item) =>
      typeof item === "string"
        ? { value: item, label: item }
        : {
            value: item.value ?? item.id,
            label: item.label ?? item.lable ?? item.name ?? item.value ?? item.id,
          }
    );

  const buildBotMessageFromStep = async (step, idPrefix = "bot", datasource, apiaction, guid) => {
    const format = step?.displayformat?.name;
    let type = FORMAT_TO_TYPE[format] || "text";

    let options;
    let formFields;
    let payloadConfig;
    let actionName;
    let payloadKey;

    if (step?.starttype?.name === "Data Source") {
      const ds = step?.selectdatasource;

      if (format === "Display Form") {
        payloadConfig = JSON.parse(ds?.storeinputpayloadconfiguration || "{}");

        actionName = payloadConfig.action;
        payloadKey = getPayloadKey(actionName);

        const fields = payloadConfig?.[payloadKey]?.fields || {};

        formFields = Object.entries(fields)
          .filter(([, cfg]) => isUserFacingField(cfg))
          .map(([name, cfg]) => ({
            name,
            label: cfg?.value || prettifyFieldLabel(name),
            controlType: inferControlType(cfg.datatype),
            options: buildOptionsFromValueList(cfg.valuelist),
            isrequired: cfg.isrequired,
          }));

        type = "form";
      } else {
        const valuefields = (ds?.valuefield || "")
          .split(";")
          .map((f) => f.trim())
          .filter(Boolean);

        const labelfield = ds?.labelfield;
        const rows =
          valuefields.map((vf) => toArray(datasource?.[vf])).find((arr) => arr.length) || [];

        options = rows.map((row) => ({
          label: `${row?.name ?? ""}-${resolveFieldDisplay(row?.[labelfield])}`,
          tableData: rows,
          value: {
            id: row?.id,
            objectname: ds?.object?.name,
            objectid: ds?.object?.id,
          },
        }));

        if (format === "Display Table" && ds?.storeinputpayloadconfiguration) {
          payloadConfig = JSON.parse(ds.storeinputpayloadconfiguration || "{}");
          actionName = payloadConfig.action;
          payloadKey = getPayloadKey(actionName);

          const fields = payloadConfig?.[payloadKey]?.fields || {};
          const isProductsDatasource = ds?.object?.name === "Products";

          formFields = Object.entries(fields)
            .filter(
              ([name, cfg]) =>
                isUserFacingField(cfg) && !(isProductsDatasource && name === "name")
            )
            .map(([name, cfg]) => ({
              name,
              label: cfg?.value || prettifyFieldLabel(name),
              // Use the datatype (same as action forms) so table cells render the right control
              controlType: inferControlType(cfg.datatype ?? name),
              options: buildOptionsFromValueList(cfg.valuelist),
              isrequired: cfg.isrequired,
            }));
        }
      }
    } else if (step?.starttype?.name === "Action" && apiaction?.storepayloadconfiguration) {
      payloadConfig = JSON.parse(apiaction?.storepayloadconfiguration) || {};
      actionName = apiaction?.selectedapi?.name;
      payloadKey = getPayloadKey(actionName);
      const fields = payloadConfig?.[payloadKey]?.fields || {};

      formFields = Object.entries(fields)
        .filter(([, cfg]) => isUserFacingField(cfg))
        .map(([name, cfg]) => ({
          name,
          label: cfg?.value || prettifyFieldLabel(name),
          controlType: inferControlType(cfg.datatype),
          options: buildOptionsFromValueList(cfg.valuelist),
          isrequired: actionName == "Create Record" ? cfg.isrequired : true,
        }));

      type = "form";
    } else {
      const isChoiceType = ["picklist", "checkbox", "inputoption"].includes(type);

      if (isChoiceType && guid && step?.displayoutputpicklist !== "user_input") {
        try {
          const payload = { parentsessionid: guid };
          const sessionRes = await AIGetSessionInputs(payload);
          const sessionData = sessionRes?.data?.data || {};

          const rawValue = sessionData[step?.displayoutputpicklist];

          if (rawValue) {
            options = String(rawValue)
              .split(";")
              .map((o) => o.trim())
              .filter(Boolean);
          }
        } catch (err) {
          console.error("[AIGetsessionInputAPI]", err);
        }
      }

      if (!options) {
        options =
          OPTION_TYPES.has(type) && step?.displayoutputpicklist !== "user_input"
            ? (step.displayoutputpicklist || "")
                .split(";")
                .map((o) => o.trim())
                .filter(Boolean)
            : undefined;
      }
    }
    const stepType = step?.starttype?.name;

    return {
      id: `${idPrefix}-${Date.now()}`,
      role: "bot",
      text:
        stepType === "Action" || stepType === "Data Source"
          ? ""
          : step?.questiondisplaytext || "",

      type,
      stepType,

      ...(options && options.length ? { options } : {}),
      ...(formFields ? { formFields, payloadConfig, actionName, payloadKey } : {}),
    };
  };

  const isStepEnd = (step) => step?.starttype?.name === "End";

  const sendMessage = async (text) => {
    try {
      const response = await AIIntentListAPI({ message: text, journeystartsfrom: 493 });
      const rankings = response?.data?.rankings;

      if (Array.isArray(rankings) && rankings.length > 0) {
        // Bot message that renders clickable intent boxes
        setMessages((prev) => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            role: "bot",
            type: "intents",
            text: "Here's what I found — pick an intent:",
            rankings,
          },
        ]);
      } else {
        // Fallback: try to pull a plain reply string out of the response
        const replyText =
          response?.data?.reply ??
          response?.data?.message ??
          response?.reply ??
          response?.message ??
          (typeof response?.data === "string" ? response.data : null) ??
          "Got it!";

        setMessages((prev) => [
          ...prev,
          { id: `bot-${Date.now()}`, role: "bot", type: "text", text: replyText },
        ]);
      }
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        {
          id: `bot-error-${Date.now()}`,
          role: "bot",
          type: "text",
          text: "Sorry, something went wrong sending that. Please try again.",
        },
      ]);
    } finally {
      setSending(false);
    }
  };

  const captureSnapshot = () => ({
    messages,
    selectedExecution,
    answeredOptions,
    checkboxDraft,
    formDrafts,
    tableDrafts,
    tableBatch,
    editingRows,
    textInputDisabled,
    intentSelectionLocked,
    selectedIntentId,
  });

  const restoreSnapshot = (snapshot) => {
    if (!snapshot) return;
    setMessages(snapshot.messages);
    setSelectedExecution(snapshot.selectedExecution);
    setAnsweredOptions(snapshot.answeredOptions);
    setCheckboxDraft(snapshot.checkboxDraft);
    setFormDrafts(snapshot.formDrafts);
    setTableDrafts(snapshot.tableDrafts);
    setTableBatch(snapshot.tableBatch);
    setEditingRows(snapshot.editingRows || {});
    setTextInputDisabled(snapshot.textInputDisabled);
    setIntentSelectionLocked(snapshot.intentSelectionLocked);
    setSelectedIntentId(snapshot.selectedIntentId);
    setMessage("");
    setSending(false);
  };

  const isBackableStepType = (stepKind) =>
    !!stepKind && stepKind !== "Action" && stepKind != "Data Source" && stepKind !== "End";

  const handleGoBack = async (messageId) => {
    if (sending) return;

    const snapshot = stepHistory[messageId];
    if (!snapshot) return;

    const currentMessage = messages.find((m) => m.id === messageId);

    if (currentMessage?.isFirstStep) {
      restoreSnapshot(snapshot);
      return;
    }

    // Other steps -> execute API before going back.
    if (selectedExecution) {
      try {
        setSending(true);

        await AIOneStepBackAPI({
          guid: selectedExecution.guid,
          currentstep: selectedExecution.step,
          currentworkflow: selectedExecution.workflow,
          currentintent: selectedExecution.intent,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setSending(false);
      }
    }

    restoreSnapshot(snapshot);
  };

  // Automatically open the table popup when a Data Source step returns rows
  const openTablePopupIfNeeded = (msg) => {
    if (
      msg?.stepType === "Data Source" &&
      msg?.type === "displaytable" &&
      msg?.options?.[0]?.tableData?.length > 0
    ) {
      setTablePopupId(msg.id);
    }
  };

  const submitAnswer = async (displayText, payloadValue, currentMessageType = "text") => {
    if (sending) return;

    const preSnapshot = captureSnapshot();

    // Only show user's reply for normal text input
    if (
      currentMessageType === "text" ||
      currentMessageType === "inputtext" ||
      currentMessageType === "number" ||
      currentMessageType === "inputnumber" ||
      currentMessageType === "html" ||
      currentMessageType === "displaytable" ||
      currentMessageType === "inputdate" ||
      currentMessageType === "inputphone" ||
      currentMessageType === "inputemail"
    ) {
      if (!displayText?.trim()) return;

      setMessages((prev) => [
        ...prev,
        {
          id: `user-${Date.now()}`,
          role: "user",
          type: "text",
          text: displayText,
        },
      ]);
    }

    setMessage("");
    setSending(true);

    if (selectedExecution) {
      try {
        const payload = {
          guid: selectedExecution.guid,
          intent: selectedExecution.intent,
          workflow: selectedExecution.workflow,
          step: selectedExecution.step,
          output: {
            userinput: payloadValue !== undefined ? payloadValue : displayText,
          },
          clientcontact: null,
        };

        const response = await AIExecutionAPI(payload);

        const nextStep = response?.data?.nextstep;
        const datasource = response?.data?.datasource;
        const apiaction = response?.data?.apiaction;
        if (!nextStep) {
          setTextInputDisabled(true);
          setSending(false);
          return;
        }
        setSelectedExecution((prev) => ({
          ...prev,
          step: nextStep?.id,
        }));

        setTextInputDisabled(isStepEnd(nextStep));

        const stepKind = nextStep?.starttype?.name;
        const nextBotMsg = {
          ...(await buildBotMessageFromStep(
            nextStep,
            "bot",
            datasource,
            apiaction,
            selectedExecution.guid
          )),
          stepType: stepKind,
        };

        setMessages((prev) => [...prev, nextBotMsg]);
        openTablePopupIfNeeded(nextBotMsg);

        if (isBackableStepType(stepKind)) {
          setStepHistory((prev) => ({ ...prev, [nextBotMsg.id]: preSnapshot }));
        }
      } catch (err) {
        setMessages((prev) => [
          ...prev,
          {
            id: `bot-${Date.now()}`,
            role: "bot",
            type: "text",
            text: err?.response?.data?.message || "Something went wrong. Please try again.",
          },
        ]);
      } finally {
        setSending(false);
      }

      return;
    }

    // Initial user message
    sendMessage(displayText);
  };

  const handleIntentClick = async (ranking) => {
    if (intentSelectionLocked) return;

    // Snapshot of "no intent picked yet" state, so the resulting first step
    // (if it's a question) can offer a way back to this exact point.
    const preSnapshot = captureSnapshot();

    setIntentSelectionLocked(true);
    setSelectedIntentId(ranking.intent.recordid);

    const guid = executionGuid || crypto.randomUUID();

    if (!executionGuid) {
      setExecutionGuid(guid);
    }

    setSelectedExecution({
      guid,
      intent: ranking?.intent?.recordid ? Number(ranking.intent.recordid.slice(5)) : null,
      workflow: ranking?.workflow?.recordid ? Number(ranking.workflow.recordid.slice(5)) : null,
      step: ranking?.first_step?.id,
      parameterstonextstep: ranking?.first_step?.parameterstonextstep || "userinput",
    });

    setTextInputDisabled(isStepEnd(ranking?.first_step));

    const stepKind = ranking?.first_step?.starttype?.name;
    const botMsg = {
      ...(await buildBotMessageFromStep(
        ranking?.first_step,
        "bot",
        ranking?.datasource,
        ranking?.apiaction,
        guid
      )),
      stepType: stepKind,
      isFirstStep: true,
    };

    setMessages((prev) => [...prev, botMsg]);

    if (isBackableStepType(stepKind)) {
      setStepHistory((prev) => ({ ...prev, [botMsg.id]: preSnapshot }));
    }

    inputRef.current?.focus();
  };

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed) return;

    if (isDateInput) {
      submitAnswer(formatDateForDisplay(trimmed), trimmed, lastMessage?.type || "text");
      return;
    }

    if (isEmailInput && !isValidEmail(trimmed)) {
      return;
    }

    if (isPhoneInput) {
      const digitsOnly = trimmed.replace(/[^\d]/g, "");
      const fullPhone = `${footerCountryCode}${digitsOnly}`;
      submitAnswer(`+${footerCountryCode}${digitsOnly}`, fullPhone, lastMessage?.type || "text");
      return;
    }

    submitAnswer(trimmed, undefined, lastMessage?.type || "text");
  };

  const isMessageActive = (m) =>
    messages.length > 0 && messages[messages.length - 1].id === m.id && !answeredOptions[m.id];

  const handleChoiceSubmit = (m, option) => {
    if (!isMessageActive(m) || sending) return;

    setAnsweredOptions((prev) => ({
      ...prev,
      [m.id]: getOptionKey(option),
    }));

    submitAnswer(getOptionLabel(option), getOptionValue(option), m.type);
  };

  const toggleCheckboxOption = (m, option) => {
    if (!isMessageActive(m) || sending) return;
    const key = getOptionKey(option);
    setCheckboxDraft((prev) => {
      const current = prev[m.id] || [];
      const isPresent = current.some((o) => getOptionKey(o) === key);
      const next = isPresent
        ? current.filter((o) => getOptionKey(o) !== key)
        : [...current, option];
      return { ...prev, [m.id]: next };
    });
  };

  const submitCheckboxSelection = (m) => {
    const selected = checkboxDraft[m.id] || [];

    if (!selected.length || !isMessageActive(m) || sending) {
      return;
    }

    const joinedKeys = selected.map(getOptionKey).join(";");
    const joinedLabels = selected.map(getOptionLabel).join(";");
    const values = selected.map(getOptionValue);

    const payloadValue = values.every((v) => v !== undefined) ? values : undefined;

    setAnsweredOptions((prev) => ({
      ...prev,
      [m.id]: joinedKeys,
    }));

    submitAnswer(joinedLabels, payloadValue, m.type);
  };

  // ---- "Action" step user-input form handlers ----

  const handleFormFieldChange = (messageId, fieldName, value) => {
    setFormDrafts((prev) => ({
      ...prev,
      [messageId]: { ...(prev[messageId] || {}), [fieldName]: value },
    }));
  };

  const isFormComplete = (m) => {
    const draft = formDrafts[m.id] || {};

    return (m.formFields || []).every((f) => {
      const value = draft[f.name];
      const filled = isFieldFilled(f, value);

      if (isRequiredField(f) && !filled) {
        return false;
      }

      if (f.controlType === "Email" && filled && !isValidEmail(value)) {
        return false;
      }

      return true;
    });
  };

  const submitFormSelection = async (m) => {
    if (!isMessageActive(m) || sending || !isFormComplete(m)) {
      return;
    }

    const draft = formDrafts[m.id] || {};
    const payloadConfig = m.payloadConfig;
    const actionName = m.actionName;
    const payloadKey = m.payloadKey || getPayloadKey(actionName);
    const cfg = payloadConfig?.[payloadKey] || {};

    let finalPayload;

    if (SMS_LIKE_ACTIONS.has(actionName)) {
      const smsFields = buildSmsLikeFields(cfg);

      await Promise.all(
        Object.keys(smsFields).map(async (key) => {
          const draftValue = draft[key];
          if (Array.isArray(draftValue) && draftValue.some((f) => f instanceof File)) {
            smsFields[key] = {
              ...smsFields[key],
              value: await filesToPayload(draftValue),
            };
          }
        })
      );

      finalPayload = {
        action: actionName,
        islist: false,

        [payloadKey]: {
          fields: smsFields,
          tablename: cfg.tablename,
          businessprocess: cfg.businessprocess ?? null,
        },
      };
    } else {
      const fields = cfg.fields || {};
      const ObjectInsertInto = cfg.tablename;

      const finalFields = {};
      for (const [key, fieldCfg] of Object.entries(fields)) {
        if (isUserFacingField(fieldCfg)) {
          const draftValue = draft[key];
          const formField = (m.formFields || []).find((f) => f.name === key);

          let value = Array.isArray(draftValue)
            ? await filesToPayload(draftValue)
            : draftValue ?? "";

          // UI shows 6, backend expects 0.06
          if (isPercentageField(formField)) {
            value = percentToPayload(value);
          }

          finalFields[key] = {
            type: fieldCfg?.type,
            value,
          };
        } else {
          finalFields[key] = {
            type: fieldCfg?.type,
            value: fieldCfg?.value || "",
          };
        }
      }

      if (ObjectInsertInto === "deallineitems" || ObjectInsertInto === "clientcontact") {
        const nameFieldCfg = fields.name;
        if (
          !nameFieldCfg ||
          nameFieldCfg.type === "userinput" ||
          nameFieldCfg.type === "fromprevstep"
        ) {
          const nameValue =
            ObjectInsertInto === "clientcontact"
              ? `${draft?.firstname ?? ""} ${draft?.lastname ?? ""}`.trim()
              : draft?.label ?? draft?.name ?? "";

          finalFields.name = {
            type: "predefined",
            value: nameValue,
          };
        }
      }

      finalPayload = {
        action: actionName === "Search Single Record" ? "Search Record" : actionName,
        islist: false,
        ...(payloadConfig?.queryfilter?.length > 0 && {
          queryfilter: payloadConfig.queryfilter,
        }),

        [payloadKey === "getsinglerecord" ? "getsinglerecordpayload" : payloadKey]: {
          ...cfg,
          fields: finalFields,
        },
      };
    }

    setAnsweredOptions((prev) => ({
      ...prev,
      [m.id]: (m.formFields || []).length
        ? JSON.stringify(
            Object.fromEntries(
              Object.entries(draft).map(([k, v]) => [
                k,
                Array.isArray(v) ? v.map((f) => f?.name) : v,
              ])
            )
          )
        : "confirmed",
    }));

    submitAnswer("", finalPayload, m.type);
  };

  // ---- Display Table per-row userinput handlers ----

  const handleTableFieldChange = (messageId, rowId, fieldName, value) => {
    setTableDrafts((prev) => ({
      ...prev,
      [messageId]: {
        ...(prev[messageId] || {}),
        [rowId]: { ...(prev[messageId]?.[rowId] || {}), [fieldName]: value },
      },
    }));
  };

  // prefilled values + anything the user has typed (user edits win, even if cleared)
  const getRowDraft = (m, row) => ({
    ...getInitialRowDraft(m, row),
    ...(tableDrafts[m.id]?.[row?.id] || {}),
  });

  // Update Record rows are read-only until the edit icon is clicked.
  // Every other action keeps its inputs enabled.
  const canEditRow = (m, rowId) =>
    m.actionName !== "Update Record" || !!editingRows[m.id]?.[rowId];

  const startEditRow = (m, rowId) => {
    if (!isMessageActive(m) || sending) return;
    setEditingRows((prev) => ({
      ...prev,
      [m.id]: { ...(prev[m.id] || {}), [rowId]: true },
    }));
  };

  const isTableRowComplete = (m, rowId) => {
    const row = (m.options?.[0]?.tableData || []).find((r) => r.id === rowId);
    const rowDraft = getRowDraft(m, row);
    const fields = m.formFields || [];

    // every required field must be filled
    const requiredOk = fields.every(
      (f) => !isRequiredField(f) || isFieldFilled(f, rowDraft[f.name])
    );

    // optional emails are fine when empty, but must be valid if typed
    const emailOk = fields.every(
      (f) =>
        f.controlType !== "Email" ||
        !isFieldFilled(f, rowDraft[f.name]) ||
        isValidEmail(rowDraft[f.name])
    );

    // if nothing is marked required, still block completely empty rows
    const hasRequired = fields.some(isRequiredField);
    const anyFilled = fields.some((f) => isFieldFilled(f, rowDraft[f.name]));

    return requiredOk && emailOk && (hasRequired || anyFilled);
  };

  const buildTableRowFields = (m, row, rowDraft) => {
    const payloadConfig = m.payloadConfig;
    const actionName = m.actionName;
    const payloadKey = m.payloadKey || getPayloadKey(actionName);

    const cfg = payloadConfig?.[payloadKey] || {};
    const fields = cfg.fields || {};

    const datasourceObjectName = m.options?.[0]?.value?.objectname;
    const ObjectInsertInto = cfg.tablename;

    const finalFields = {};

    for (const [key, fieldCfg] of Object.entries(fields)) {
      if (fieldCfg?.type === "userinput") {
        const formField = (m.formFields || []).find((f) => f.name === key);
        const raw = rowDraft[key] ?? "";

        finalFields[key] = {
          type: "userinput",
          value: isPercentageField(formField) ? percentToPayload(raw) : raw,
        };
      } else if (fieldCfg?.type === "fromprevstep") {
        const referencesDatasourceObject =
          datasourceObjectName != null && fieldCfg.value === datasourceObjectName;

        finalFields[key] = {
          type: "fromprevstep",
          value: referencesDatasourceObject ? row?.id : "",
        };
      } else {
        finalFields[key] = {
          type: fieldCfg?.type,
          value: fieldCfg?.value,
        };
      }
    }
    if (ObjectInsertInto === "deallineitems" || ObjectInsertInto === "clientcontact") {
      const nameFieldCfg = fields.name;
      if (
        !nameFieldCfg ||
        nameFieldCfg.type === "userinput" ||
        nameFieldCfg.type === "fromprevstep"
      ) {
        const nameValue =
          ObjectInsertInto === "clientcontact"
            ? `${rowDraft?.firstname ?? ""} ${rowDraft?.lastname ?? ""}`.trim()
            : row?.label ?? row?.name ?? "";

        finalFields.name = {
          type: "predefined",
          value: nameValue,
        };
      }
    }
    if (actionName === "Update Record") {
      finalFields.recordid = {
        type: "fromprevstep",
        value: row?.recordid ?? "",
      };
    }

    return finalFields;
  };

  const isTableRowQueued = (m, rowId) => !!tableBatch[m.id]?.byRow?.[rowId];

  const tableBatchCount = (m) => tableBatch[m.id]?.order?.length || 0;

  const toggleTableRowQueued = (m, row) => {
    if (!isMessageActive(m) || sending) return;

    setTableBatch((prev) => {
      const current = prev[m.id] || { order: [], byRow: {} };
      const isQueued = !!current.byRow[row.id];

      if (isQueued) {
        const { [row.id]: _removed, ...restByRow } = current.byRow;
        return {
          ...prev,
          [m.id]: {
            order: current.order.filter((id) => id !== row.id),
            byRow: restByRow,
          },
        };
      }

      if (!isTableRowComplete(m, row.id)) return prev;

      const rowDraft = getRowDraft(m, row);
      const fields = buildTableRowFields(m, row, rowDraft);
      const label = row?.name || row?.productcode || `Row ${row?.id}`;
      const summary = (m.formFields || [])
        .filter((f) => isFieldFilled(f, rowDraft[f.name]))
        .map((f) => `${f.label}: ${formatDraftValue(f, rowDraft[f.name])}`)
        .join(", ");

      return {
        ...prev,
        [m.id]: {
          order: [...current.order, row.id],
          byRow: { ...current.byRow, [row.id]: { fields, label, summary } },
        },
      };
    });
  };

  const submitTableBatch = async (m) => {
    const batch = tableBatch[m.id];
    if (!batch || !batch.order.length || !isMessageActive(m) || sending) return;

    const payloadConfig = m.payloadConfig;
    const actionName = m.actionName;
    const payloadKey = m.payloadKey || getPayloadKey(actionName);
    const cfg = payloadConfig?.[payloadKey] || {};

    const displaySummary = batch.order
      .map((rowId) => `${batch.byRow[rowId].label} (${batch.byRow[rowId].summary})`)
      .join("; ");

    // Lock the message first so it can't be double-submitted while files convert
    setAnsweredOptions((prev) => ({
      ...prev,
      [m.id]: `batch-${batch.order.join(",")}`,
    }));

    // Convert any File values to base64 before sending
    const fieldsArray = await Promise.all(
      batch.order.map(async (rowId) => {
        const fields = { ...batch.byRow[rowId].fields };
        await Promise.all(
          Object.keys(fields).map(async (key) => {
            const v = fields[key]?.value;
            if (Array.isArray(v) && v.some((f) => f instanceof File)) {
              fields[key] = { ...fields[key], value: await filesToPayload(v) };
            }
          })
        );
        return fields;
      })
    );

    const finalPayload = {
      action: actionName,
      islist: true,
      [payloadKey]: {
        tablename: cfg.tablename,
        fields: fieldsArray,
        decisionengine: cfg.decisionengine,
        validationrules: cfg.validationrules,
        approvalprocess: cfg.approvalprocess,
      },
    };

    submitAnswer(
      displaySummary,
      finalPayload,
      m.formFields?.length ? "displaytablebatch" : m.type
    );
  };

  // Resets the conversation back to the welcome message.
  // Does NOT close the panel and does NOT touch the login refs (no re-login).
  const handleEndChat = () => {
    // Reset execution
    setExecutionGuid(null);
    setSelectedExecution(null);
    setIntentSelectionLocked(false);
    setSelectedIntentId(null);
    setAnsweredOptions({});
    setCheckboxDraft({});
    setFormDrafts({});
    setTableDrafts({});
    setTableBatch({});
    setEditingRows({});
    setStepHistory({});
    setTablePopupId(null);
    // Clear input
    setMessage("");
    setSending(false);
    setTextInputDisabled(false);

    // Reset chat history
    setMessages([
      {
        id: "welcome",
        role: "bot",
        type: "text",
        text: "Welcome! How can I help you today?",
      },
    ]);
  };

  const lastMessage = messages[messages.length - 1];
  const isPhoneInput = lastMessage?.type === "inputphone";
  const isNumericInput = lastMessage?.type === "inputnumber" || isPhoneInput;
  const isChoiceOnlyInput = lastMessage && CHOICE_TYPES.has(lastMessage.type);
  const isDateInput = lastMessage?.type === "inputdate";
  const isEmailInput = lastMessage?.type === "inputemail";

  const handleMessageChange = (e) => {
    const val = e.target.value;

    if (isNumericInput) {
      if (val === "" || /^-?\d*\.?\d*$/.test(val)) {
        setMessage(val);
      }
    } else {
      setMessage(val);
    }
  };

  const optionChipSx = (isSelected, isDisabled) => ({
    px: 1.25,
    py: 1,
    border: `1px solid ${isSelected ? ACCENT : "#D9D6CC"}`,
    borderRadius: "10px",
    fontSize: 13,
    fontWeight: 600,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    transition: "all .15s ease",
    cursor: isDisabled ? "default" : "pointer",
    userSelect: "none",
    bgcolor: isSelected ? ACCENT : "#fff",
    color: isSelected ? "#fff" : isDisabled ? "#B7B4AC" : ACCENT,
    opacity: isDisabled && !isSelected ? 0.55 : 1,
    "&:hover": !isDisabled && {
      bgcolor: isSelected ? ACCENT_DARK : `${ACCENT}14`,
    },
  });

  const isSendDisabled =
    sending || !message.trim() || (isEmailInput && !isValidEmail(message));

  const showChatFooter =
    !textInputDisabled &&
    (lastMessage?.type === "text" ||
      lastMessage?.type === "inputtext" ||
      lastMessage?.type === "inputnumber" ||
      lastMessage?.type === "number" ||
      lastMessage?.type === "html" ||
      lastMessage?.type === "inputdate" ||
      lastMessage?.type === "displaypicklist" ||
      (lastMessage?.type === "displaytable" &&
        !(lastMessage?.formFields && lastMessage.formFields.length > 0)) ||
      lastMessage?.type === "inputphone" ||
      lastMessage?.type === "inputemail");

  // ---- Display Table content (used inline in the chat and inside the popup dialog) ----
  // fit:    squeeze all columns into the container width (popup) instead of scrolling
  // filter: apply the popup search box (off for the inline table)
  const renderTableContent = (m, { fit = false, filter = true } = {}) => {
    const active = isMessageActive(m);
    const tableData = m.options?.[0]?.tableData || [];
    if (!tableData.length) return null;

    const columns = getReadColumns(m, tableData);

    // userinput fields parsed from inputpayloadconfiguration
    const extraFields = m.formFields || [];
    const hasExtra = extraFields.length > 0;

    const query = filter ? tableSearch.trim().toLowerCase() : "";
    const filteredData = query
      ? tableData.filter((row) =>
          columns.some((column) =>
            String(getValue(row[column]) ?? "").toLowerCase().includes(query)
          )
        )
      : tableData;

    const inputWidths = extraFields.map(getTableInputWidth);

    // total "weight" of all columns, used to turn px widths into percentages
    const totalPx =
      columns.length * TABLE_READ_COL_PX +
      inputWidths.reduce((a, b) => a + b, 0) +
      (hasExtra ? TABLE_ACTION_COL_PX : 0);

    const toPct = (px) => `${(px / totalPx) * 100}%`;

    const readColWidth = fit
      ? toPct(TABLE_READ_COL_PX)
      : hasExtra
        ? TABLE_READ_COL_PX
        : `${100 / columns.length}%`;

    const actionColWidth = fit ? toPct(TABLE_ACTION_COL_PX) : TABLE_ACTION_COL_PX;

    const getInputColWidth = (i) => (fit ? toPct(inputWidths[i]) : inputWidths[i]);

    const tableMinWidth = fit
      ? 0
      : hasExtra
        ? columns.length * TABLE_READ_COL_PX +
          inputWidths.reduce((a, b) => a + b, 0) +
          TABLE_ACTION_COL_PX
        : 0;

    const headCellSx = {
      backgroundColor: ACCENT,
      color: "#fff",
      fontWeight: 700,
      fontFamily: fontFamilyall,
    };

    return (
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: "100%",
          border: "1px solid #E3E1DA",
          borderRadius: 2,
          overflowX: fit ? "hidden" : "auto",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Table
          size="small"
          sx={{
            width: "100%",
            minWidth: tableMinWidth,
            tableLayout: "fixed",
            borderCollapse: "separate",
            "& .MuiTableCell-root": {
              fontFamily: fontFamilyall,
              fontSize: "12px",
              py: 1,
              px: 1,
              borderColor: "#ECEAE4",
              verticalAlign: "middle",
            },
          }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column}
                  align="left"
                  sx={{
                    ...headCellSx,
                    width: readColWidth,
                    textTransform: "capitalize",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {column.replace(/_/g, " ")}
                </TableCell>
              ))}

              {/* one header per userinput field, sized to its control */}
              {extraFields.map((field, i) => (
                <TableCell
                  key={field.name}
                  align="left"
                  sx={{
                    ...headCellSx,
                    width: getInputColWidth(i),
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {field.name
                    ?.split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                  {isRequiredField(field) && (
                    <Box component="span" sx={{ color: "#FFD1D1", ml: 0.5 }}>
                      *
                    </Box>
                  )}
                </TableCell>
              ))}

              {hasExtra && (
                <TableCell align="center" sx={{ ...headCellSx, width: actionColWidth }}>
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={columns.length + extraFields.length + (hasExtra ? 1 : 0)}
                  align="center"
                  sx={{ color: "#9B978C", py: 3 }}
                >
                  No matching records
                </TableCell>
              </TableRow>
            )}

            {filteredData.map((row, index) => {
              const rowDraft = getRowDraft(m, row);
              const rowComplete = isTableRowComplete(m, row.id);
              const isQueued = isTableRowQueued(m, row.id);

              return (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    "&:nth-of-type(even)": { backgroundColor: "#FAFAFA" },
                    "&:last-of-type .MuiTableCell-root": { borderBottom: "none" },
                    ...(isQueued && { backgroundColor: `${ACCENT}0F` }),
                  }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column}
                      align="left"
                      sx={{
                        width: readColWidth,
                        fontFamily: fontFamilyall,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {getValue(row[column] ?? "-")}
                    </TableCell>
                  ))}

                  {/* editable cells per row, rendered by field datatype */}
                  {extraFields.map((field, i) => {
                    const cellDisabled =
                      !active || sending || isQueued || !canEditRow(m, row.id);
                    const cellId = `${m.id}-${row.id}-${field.name}`;

                    return (
                      <TableCell
                        key={field.name}
                        align="left"
                        sx={{ width: getInputColWidth(i) }}
                      >
                        {field.controlType === "file" ? (
                          <TableFileCell
                            id={cellId}
                            value={rowDraft[field.name] ?? []}
                            disabled={cellDisabled}
                            onChange={(val) =>
                              handleTableFieldChange(m.id, row.id, field.name, val)
                            }
                            accent={ACCENT}
                            accentDark={ACCENT_DARK}
                            fontFamily={fontFamilyall}
                          />
                        ) : (
                          renderField(
                            field,
                            rowDraft[field.name] ?? "",
                            (val) => handleTableFieldChange(m.id, row.id, field.name, val),
                            {
                              disabled: cellDisabled,
                              accent: ACCENT,
                              textColor: TextColor,
                              fontFamily: fontFamilyall,
                              hideLabel: true,
                              compact: true,
                              idPrefix: `${m.id}-${row.id}`,
                            }
                          )
                        )}
                      </TableCell>
                    );
                  })}

                  {hasExtra && (
                    <TableCell align="center" sx={{ width: actionColWidth }}>
                      <Button
                        size="small"
                        disabled={
                          !active ||
                          sending ||
                          (!isQueued && canEditRow(m, row.id) && !rowComplete)
                        }
                        onClick={() =>
                          isQueued || canEditRow(m, row.id)
                            ? toggleTableRowQueued(m, row)
                            : startEditRow(m, row.id)
                        }
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          bgcolor: isQueued ? "#fff" : ACCENT,
                          border: isQueued ? `1px solid ${ACCENT}` : "1px solid transparent",
                          fontFamily: fontFamilyall,
                          color: isQueued ? ACCENT : "#fff",
                          minWidth: 26,
                          width: 26,
                          height: 26,
                          p: 0,
                          "&:hover": {
                            bgcolor: isQueued ? `${ACCENT}14` : ACCENT_DARK,
                          },
                          "&.Mui-disabled": {
                            bgcolor: "#EDEBE5",
                            color: "#B7B4AC",
                            border: "1px solid transparent",
                          },
                        }}
                      >
                        {isQueued ? (
                          <CheckIcon fontSize="small" />
                        ) : canEditRow(m, row.id) ? (
                          <AddIcon fontSize="small" />
                        ) : (
                          <EditOutlinedIcon fontSize="small" />
                        )}
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const getTableDialogTitle = (m) => {
    const objectName = m?.options?.[0]?.value?.objectname;
    const hasInputs = (m?.formFields || []).length > 0;

    const base = objectName ? prettifyFieldLabel(objectName) : "Table";

    if (hasInputs) {
      // Editable table: the user fills in values per row and submits
      return `${base}`;
    }
    return `${base} List`;
  };

  const batchButtonLabel = (m, active) => {
    const count = tableBatchCount(m);
    const isCreate = m.actionName === "Create Record";
    return active
      ? `${isCreate ? "Submit" : "Update"} ${count} record${count === 1 ? "" : "s"}`
      : isCreate
        ? "Submitted"
        : "Updated";
  };

  const batchButtonSx = {
    textTransform: "none",
    fontSize: 12,
    fontWeight: 700,
    borderRadius: "999px",
    bgcolor: ACCENT,
    fontFamily: fontFamilyall,
    color: "#fff",
    px: 2,
    py: 0.5,
    "&:hover": { bgcolor: ACCENT_DARK },
    "&.Mui-disabled": { bgcolor: "#EDEBE5", color: "#B7B4AC" },
  };

  const continuePaperSx = {
    bgcolor: PageBackgroundColor,
    color: TextColor,
    border: "1px solid #ECEAE4",
    px: 1.75,
    py: 1.5,
    maxWidth: "80%",
    borderRadius: "4px 16px 16px 16px",
    fontSize: 14,
    lineHeight: 1.5,
    boxShadow: "0 2px 6px rgba(27,27,31,0.05)",
    wordBreak: "break-word",
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 1300,
      }}
    >
      {/* Chat panel */}
      <Grow in={open} style={{ transformOrigin: "right center" }} timeout={220}>
        <Paper
          elevation={0}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            width: PANEL_WIDTH,
            height: "600px",
            maxWidth: "calc(100vw - 48px)",
            maxHeight: "calc(100vh - 40px)",
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 12px 32px rgba(27,27,31,0.18)",
            zIndex: 19,
            pointerEvents: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              bgcolor: ACCENT,
              color: "#fff",
              px: 2.25,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Badge
                variant="dot"
                sx={{
                  "& .MuiBadge-badge": {
                    bgcolor: "#7CFFB2",
                    boxShadow: "0 0 0 3px rgba(124,255,178,0.25)",
                    width: 9,
                    height: 9,
                    minWidth: 9,
                    borderRadius: "50%",
                    position: "static",
                  },
                }}
              />

              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    color: "inherit",
                    fontFamily: fontFamilyall,
                  }}
                >
                  Mica Agent
                </Typography>

                <Typography
                  sx={{
                    fontSize: 11,
                    opacity: 0.85,
                    mt: 0.25,
                    fontFamily: fontFamilyall,
                  }}
                >
                  Online
                </Typography>
              </Box>
            </Box>

            {/* Header actions: End Chat */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton
                onClick={handleEndChat}
                size="small"
                sx={{
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "8px",
                  px: 1,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
                }}
              >
                <CloseIcon sx={{ fontSize: 14 }} />
                <Typography sx={{ ml: 0.5, fontSize: 11, fontFamily: fontFamilyall }}>
                  End Chat
                </Typography>
              </IconButton>
            </Box>
          </Box>

          {/* Body — scrollable message list */}
          <Box
            sx={{
              px: 2.25,
              py: 2.25,
              bgcolor: primaryColor,
              height: "600px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 1,
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#D9D6CC",
                borderRadius: 3,
              },
            }}
          >
            {messages.map((m) => {
              const isUnanimatedBotText = m.role === "bot" && !animatedIdsRef.current.has(m.id);
              const active = isMessageActive(m);
              const answer = answeredOptions[m.id];

              return (
                <Grow in key={m.id} timeout={300}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: m.role === "user" ? "flex-end" : "flex-start",
                      gap: 0.75,
                    }}
                  >
                    {(m.text || m.type === "html") &&
                      !(m.stepType === "Data Source" && m.type === "displaytable") && (
                        <Paper
                          elevation={0}
                          sx={{
                            bgcolor: m.role === "user" ? ACCENT : PageBackgroundColor,
                            color: m.role === "user" ? "#fff" : TextColor,
                            border: m.role === "user" ? "none" : "1px solid #ECEAE4",
                            px: 1.75,
                            py: 1.5,
                            maxWidth: "80%",
                            borderRadius:
                              m.role === "user" ? "16px 4px 16px 16px" : "4px 16px 16px 16px",
                            fontSize: 14,
                            lineHeight: 1.5,
                            boxShadow: "0 2px 6px rgba(27,27,31,0.05)",
                            wordBreak: "break-word",
                          }}
                        >
                          {m.isFirstStep ? (
                            m.type === "html" ? (
                              <Box dangerouslySetInnerHTML={{ __html: m.text || "" }} />
                            ) : (
                              m.text
                            )
                          ) : isUnanimatedBotText ? (
                            m.type === "html" ? (
                              <TypewriterText
                                text={m.text}
                                speed={18}
                                onTick={scrollToBottom}
                                onDone={() => animatedIdsRef.current.add(m.id)}
                                renderAsHtml
                              />
                            ) : (
                              <TypewriterText
                                text={m.text}
                                speed={18}
                                onTick={scrollToBottom}
                                onDone={() => animatedIdsRef.current.add(m.id)}
                              />
                            )
                          ) : m.type === "html" ? (
                            <Box dangerouslySetInnerHTML={{ __html: m.text || "" }} />
                          ) : (
                            m.text
                          )}
                        </Paper>
                      )}

                    {/* Clickable intent boxes */}
                    {m.type === "intents" && (
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: 1,
                          maxWidth: "80%",
                          width: "100%",
                        }}
                      >
                        {m.rankings.map((ranking, idx) => {
                          const isSelected = selectedIntentId === ranking.intent.recordid;
                          const isDisabled = intentSelectionLocked && !isSelected;
                          return (
                            <Paper
                              key={`${m.id}-intent-${idx}`}
                              elevation={0}
                              onClick={() => handleIntentClick(ranking)}
                              sx={{
                                ...optionChipSx(isSelected, isDisabled),
                                pointerEvents: intentSelectionLocked ? "none" : "auto",
                              }}
                            >
                              {ranking?.intent?.name ?? "Untitled intent"}
                            </Paper>
                          );
                        })}
                      </Box>
                    )}

                    {m.type === "picklist" && (
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: 1,
                          width: "100%",
                          maxWidth: "80%",
                        }}
                      >
                        {(m.options || []).map((option, index) => {
                          const isSelected = answer === getOptionKey(option);
                          const isDisabled = !active && !isSelected;
                          return (
                            <Paper
                              key={`${m.id}-${index}`}
                              elevation={0}
                              onClick={() => handleChoiceSubmit(m, option)}
                              sx={optionChipSx(isSelected, isDisabled)}
                            >
                              {isSelected && <CheckCircleIcon sx={{ fontSize: 15 }} />}
                              {getOptionLabel(option)}
                            </Paper>
                          );
                        })}
                      </Box>
                    )}

                    {(m.type === "inputoption" || m.type === "button") && (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 1,
                          width: "100%",
                          maxWidth: "80%",
                        }}
                      >
                        {(m.options || []).map((option, index) => {
                          const optionKey = getOptionKey(option);
                          const isSelected = answer === optionKey;
                          const isDisabled = !active && !isSelected;

                          return (
                            <FormControlLabel
                              key={`${m.id}-${index}`}
                              value={optionKey}
                              control={
                                <Radio
                                  checked={isSelected}
                                  disabled={isDisabled}
                                  onChange={() => handleChoiceSubmit(m, option)}
                                  size="small"
                                  sx={{
                                    padding: "4px",
                                    color: secondaryColor,
                                    "&.Mui-checked": { color: secondaryColor },
                                  }}
                                />
                              }
                              label={getOptionLabel(option)}
                              sx={{
                                margin: 0,
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "13px",
                                  fontFamily: fontFamilyall,
                                  color: isDisabled ? "#999" : TextColor,
                                },
                              }}
                            />
                          );
                        })}
                      </Box>
                    )}

                    {/* Input Checkbox — multi choice, explicit submit */}
                    {m.type === "checkbox" && (
                      <Box sx={{ width: "100%", maxWidth: "80%" }}>
                        <Box
                          sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 1 }}
                        >
                          {(m.options || []).map((option, index) => {
                            const key = getOptionKey(option);
                            const draft = checkboxDraft[m.id] || [];
                            const isChecked = answer
                              ? answer.split(";").includes(key)
                              : draft.some((o) => getOptionKey(o) === key);
                            const isDisabled = !active;
                            return (
                              <Paper
                                key={`${m.id}-${index}`}
                                elevation={0}
                                onClick={() => toggleCheckboxOption(m, option)}
                                sx={optionChipSx(isChecked, isDisabled)}
                              >
                                {isChecked ? (
                                  <CheckBoxIcon sx={{ fontSize: 16 }} />
                                ) : (
                                  <CheckBoxOutlineBlankIcon sx={{ fontSize: 16 }} />
                                )}
                                {getOptionLabel(option)}
                              </Paper>
                            );
                          })}
                        </Box>

                        {active && (
                          <Button
                            size="small"
                            disabled={!(checkboxDraft[m.id] || []).length || sending}
                            onClick={() => submitCheckboxSelection(m)}
                            sx={{
                              mt: 1,
                              textTransform: "none",
                              borderRadius: "999px",
                              fontSize: 12,
                              fontWeight: 600,
                              bgcolor: ACCENT,
                              fontFamily: fontFamilyall,
                              color: "#fff",
                              px: 2,
                              "&:hover": { bgcolor: ACCENT_DARK },
                              "&.Mui-disabled": { bgcolor: "#E3E1DA", color: "#fff" },
                            }}
                          >
                            Send
                          </Button>
                        )}
                      </Box>
                    )}

                    {/* Display Table — "Expand Table" and "Download CSV" sit in one row. */}
                    {m.type === "displaytable" && m.options?.[0]?.tableData?.length > 0 &&
                      (() => {
                        const tableData = m.options[0].tableData;
                        const csvColumns = Object.keys(tableData[0])
                          .filter((c) => c.toLowerCase() !== "id")
                          .slice(0, 4);

                        const pillSx = {
                          textTransform: "none",
                          fontSize: 12,
                          fontWeight: 700,
                          borderRadius: "999px",
                          px: 1.75,
                          py: 0.5,
                          color: ACCENT,
                          bgcolor: `${ACCENT}14`,
                          fontFamily: fontFamilyall,
                          whiteSpace: "nowrap",
                          "&:hover": { bgcolor: ACCENT, color: "#fff" },
                        };

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Button
                              size="small"
                              onClick={() => setTablePopupId(m.id)}
                              startIcon={<TableChartIcon sx={{ fontSize: 16 }} />}
                              sx={pillSx}
                            >
                              Expand Table
                            </Button>

                            <Button
                              size="small"
                              onClick={() => downloadCSV(tableData, csvColumns)}
                              startIcon={<DownloadIcon sx={{ fontSize: 15 }} />}
                              sx={pillSx}
                            >
                              Download CSV
                            </Button>
                          </Box>
                        );
                      })()}

                    {/* Display Table — inline version: read-only columns + editable userinput
                        columns (rendered by datatype) + per-row Add/Edit */}
                    {m.type === "displaytable" && m.options?.[0]?.tableData?.length > 0 && (
                      <>
                        {renderTableContent(m, { filter: false })}

                        {/* Batch summary + combined submit — sends every queued row
                            as one payload in a single execution call */}
                        {(m.formFields || []).length > 0 && (
                          <Box
                            sx={{
                              width: "100%",
                              mt: 0.5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#77746A",
                                fontFamily: fontFamilyall,
                              }}
                            >
                              {tableBatchCount(m)} record{tableBatchCount(m) === 1 ? "" : "s"} added
                            </Typography>

                            <Button
                              size="small"
                              disabled={!active || sending || tableBatchCount(m) === 0}
                              onClick={() => submitTableBatch(m)}
                              sx={batchButtonSx}
                            >
                              {batchButtonLabel(m, active)}
                            </Button>
                          </Box>
                        )}
                      </>
                    )}

                    {/* Display Picklist - display only, no selection */}
                    {m.type === "displaypicklist" && (
                      <>
                        <Paper
                          elevation={0}
                          sx={{
                            bgcolor: PageBackgroundColor,
                            border: "1px solid #ECEAE4",
                            borderRadius: 2,
                            p: 1.5,
                            maxWidth: "80%",
                          }}
                        >
                          <Stack spacing={0.75}>
                            {m.options?.map((option, index) => (
                              <Box
                                key={index}
                                sx={{
                                  px: 1.5,
                                  py: 1,
                                  border: "1px solid #E5E5E5",
                                  borderRadius: 1.5,
                                  fontSize: 14,
                                  color: TextColor,
                                  backgroundColor: "#fff",
                                }}
                              >
                                {option.label ?? option.value ?? option.text}
                              </Box>
                            ))}
                          </Stack>
                        </Paper>

                        {/* Continue text after Display Picklist */}
                        <Paper elevation={0} sx={{ ...continuePaperSx, mt: 1 }}>
                          Would you like to continue to the next step?
                        </Paper>
                      </>
                    )}

                    {m.type === "form" && (m.formFields || []).length > 0 && (
                      <ActionFormCard
                        message={m}
                        active={active}
                        draft={formDrafts[m.id] || {}}
                        onFieldChange={(name, value) => handleFormFieldChange(m.id, name, value)}
                        onSubmit={() => submitFormSelection(m)}
                        sending={sending}
                        accent={ACCENT}
                        accentDark={ACCENT_DARK}
                        textColor={TextColor}
                        fontFamily={fontFamilyall}
                      />
                    )}

                    {/* Continue text AFTER Display Table */}
                    {m.stepType === "Data Source" &&
                      m.type === "displaytable" &&
                      !(m.formFields && m.formFields.length > 0) && (
                        <Paper elevation={0} sx={continuePaperSx}>
                          {"Would you like to continue to the next step?"}
                        </Paper>
                      )}

                    {isBackableStepType(m.stepType) &&
                      stepHistory[m.id] &&
                      m.id === messages[messages.length - 1].id && (
                        <Box
                          onClick={() => !sending && handleGoBack(m.id)}
                          role="button"
                          aria-label="Go back to previous question"
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.6,
                            px: 1,
                            py: 0.6,
                            borderRadius: "8px",
                            color: ACCENT,
                            fontSize: 12,
                            fontWeight: 600,
                            fontFamily: fontFamilyall,
                            cursor: sending ? "default" : "pointer",
                            opacity: sending ? 0.45 : 1,
                            pointerEvents: sending ? "none" : "auto",
                            userSelect: "none",
                            transition: "all 0.15s ease",
                            "&:hover": { bgcolor: `${ACCENT}12` },
                            "&:active": { transform: "translateX(-1px)" },
                            "&:hover svg": { transform: "translateX(-2px)" },
                          }}
                        >
                          <ArrowBackIcon
                            sx={{ fontSize: 16, transition: "transform 0.15s ease" }}
                          />
                          <Box component="span">Back</Box>
                        </Box>
                      )}
                  </Box>
                </Grow>
              );
            })}

            {sending && (
              <Box sx={{ display: "flex", justifyContent: "flex-start", px: 1 }}>
                <CircularProgress size={16} sx={{ color: ACCENT }} />
              </Box>
            )}

            <div ref={bodyEndRef} />
          </Box>

          {/* Footer */}
          {showChatFooter && (
            <Box
              sx={{
                px: 1.75,
                py: 1.5,
                borderTop: "1px solid #EEEDE8",
                display: "flex",
                gap: 1,
                bgcolor: PageBackgroundColor,
              }}
            >
              {isPhoneInput && (
                <Autocomplete
                  disableClearable
                  size="small"
                  sx={{ width: 92, flexShrink: 0 }}
                  options={DEFAULT_COUNTRY_CODES}
                  value={
                    DEFAULT_COUNTRY_CODES.find((c) => c.code === footerCountryCode) ||
                    DEFAULT_COUNTRY_CODES[0]
                  }
                  getOptionLabel={(option) => `+${option.code}`}
                  renderOption={(props, option) => (
                    <li {...props}>
                      {option.code} — {option.name}
                    </li>
                  )}
                  componentsProps={{ popper: { style: { width: 260 } } }}
                  onChange={(e, newValue) => setFooterCountryCode(newValue?.code || "1")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "999px",
                          fontSize: 13,
                          fontFamily: fontFamilyall,
                        },
                      }}
                    />
                  )}
                />
              )}
              <TextField
                inputRef={inputRef}
                value={message}
                onChange={handleMessageChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !isDateInput) {
                    handleSend();
                  }
                }}
                type={isDateInput ? "date" : "text"}
                placeholder={
                  isDateInput
                    ? "Select date"
                    : isChoiceOnlyInput
                      ? "Pick an option above…"
                      : isPhoneInput
                        ? "Phone number"
                        : isNumericInput
                          ? "Type a number…"
                          : isEmailInput
                            ? "Type a Email Address"
                            : "Type a message…"
                }
                size="small"
                fullWidth
                variant="outlined"
                disabled={sending}
                inputProps={isNumericInput ? { inputMode: "decimal" } : undefined}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "999px",
                    fontSize: 13,
                    color: TextColor,
                    fontFamily: fontFamilyall,
                    "& fieldset": { borderColor: "#E3E1DA" },
                    "&:hover fieldset": { borderColor: "#D2CFC6" },
                    "&.Mui-focused fieldset": { borderColor: ACCENT },
                  },
                  "& .MuiOutlinedInput-input": { py: 1 },
                  ...(isDateInput && { "& input": { cursor: "pointer" } }),
                }}
              />

              <IconButton
                onClick={handleSend}
                aria-label="Send"
                disabled={isSendDisabled}
                sx={{
                  bgcolor: ACCENT,
                  color: "#fff",
                  width: 36,
                  height: 36,
                  flexShrink: 0,
                  "&:hover": { bgcolor: ACCENT_DARK },
                  "&.Mui-disabled": { bgcolor: "#E3E1DA", color: "#fff" },
                }}
              >
                <SendIcon sx={{ fontSize: 15 }} />
              </IconButton>
            </Box>
          )}
        </Paper>
      </Grow>

      {/* Display Table popup: opens automatically for Data Source tables or via "Expand Table" */}
      {(() => {
        const popupMsg = messages.find((m) => m.id === tablePopupId);
        if (!popupMsg) return null;

        const tableData = popupMsg.options?.[0]?.tableData || [];
        const csvColumns = Object.keys(tableData[0] || {})
          .filter((c) => c.toLowerCase() !== "id")
          .slice(0, 4);
        const columns = getReadColumns(popupMsg, tableData);
        const extraFields = popupMsg.formFields || [];
        const hasExtra = extraFields.length > 0;

        const inputWidths = extraFields.map(getTableInputWidth);

        const tableMinWidth = hasExtra
          ? columns.length * TABLE_READ_COL_PX +
            inputWidths.reduce((a, b) => a + b, 0) +
            TABLE_ACTION_COL_PX
          : Math.max(columns.length * TABLE_READ_COL_PX, 500);

        const dialogWidth = Math.min(tableMinWidth + 158, window.innerWidth - 32);
        const popupActive = isMessageActive(popupMsg);
        const popupHasExtra = hasExtra;

        return (
          <Dialog
            open={Boolean(popupMsg)}
            onClose={() => setTablePopupId(null)}
            fullWidth
            maxWidth={false}
            fullScreen={isMobile}
            sx={{ zIndex: 1400 }}
            PaperProps={{
              sx: {
                ...(isMobile ? {} : { width: `${dialogWidth}px` }),
                maxWidth: isMobile ? "100%" : "calc(100vw - 32px)",
                borderRadius: isMobile ? 0 : "16px",
                pointerEvents: "auto",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                fontFamily: fontFamilyall,
                fontSize: 15,
                fontWeight: 700,
                py: 1.5,
              }}
            >
              {getTableDialogTitle(popupMsg)}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Tooltip title="Download as CSV">
                  <Button
                    size="small"
                    onClick={() => downloadCSV(tableData, csvColumns)}
                    startIcon={<DownloadIcon sx={{ fontSize: 15 }} />}
                    sx={{
                      textTransform: "none",
                      fontSize: 12,
                      fontWeight: 700,
                      borderRadius: "999px",
                      px: 1.5,
                      py: 0.5,
                      color: ACCENT,
                      bgcolor: `${ACCENT}14`,
                      fontFamily: fontFamilyall,
                      "&:hover": { bgcolor: ACCENT, color: "#fff" },
                    }}
                  >
                    Download CSV
                  </Button>
                </Tooltip>
                <IconButton size="small" onClick={() => setTablePopupId(null)} aria-label="Close">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </DialogTitle>

            {/* Fixed search bar: sits outside DialogContent so it never scrolls */}
            {tableData.length > 0 && (
              <Box sx={{ px: 3, py: 1.25, bgcolor: PageBackgroundColor, flexShrink: 0 }}>
                <TextField
                  value={tableSearch}
                  onChange={(e) => setTableSearch(e.target.value)}
                  placeholder="Search table…"
                  size="small"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    style: { fontFamily: fontFamilyall, fontSize: 13 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 18, color: "#9B978C" }} />
                      </InputAdornment>
                    ),
                    endAdornment: tableSearch && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => setTableSearch("")}
                          aria-label="Clear search"
                        >
                          <CloseIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "999px",
                      bgcolor: "#fff",
                      "& fieldset": { borderColor: "#E3E1DA" },
                      "&:hover fieldset": { borderColor: "#D2CFC6" },
                      "&.Mui-focused fieldset": { borderColor: ACCENT },
                    },
                  }}
                />

                {tableSearch.trim() && (
                  <Typography
                    sx={{ fontSize: 11.5, color: "#77746A", fontFamily: fontFamilyall, mt: 0.75 }}
                  >
                    {
                      tableData.filter((row) =>
                        columns.some((column) =>
                          String(getValue(row[column]) ?? "")
                            .toLowerCase()
                            .includes(tableSearch.trim().toLowerCase())
                        )
                      ).length
                    }{" "}
                    of {tableData.length} rows
                  </Typography>
                )}
              </Box>
            )}

            <DialogContent
              dividers
              sx={{ bgcolor: PageBackgroundColor, overflowX: "hidden" }}
            >
              {popupMsg.actionName === "Update Record" &&
                popupMsg.options?.[0]?.value?.objectname === "Deal Line Items" && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, m: 0.5 }}>
                    <HelpOutlineIcon sx={{ fontSize: 14, color: primaryColor }} />

                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: 11,
                        color: primaryColor,
                        fontFamily: fontFamilyall,
                        lineHeight: 1.4,
                        fontWeight: "bold",
                      }}
                    >
                      To delete the deal line item, set its quantity to 0
                    </Typography>
                  </Box>
                )}
              {renderTableContent(popupMsg, { fit: !isMobile })}
            </DialogContent>

            {/* Fixed footer: sits outside DialogContent so it never scrolls */}
            {popupHasExtra && (
              <Box
                sx={{
                  px: 3,
                  py: 1.25,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  bgcolor: PageBackgroundColor,
                  borderTop: "1px solid #ECEAE4",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: "#77746A",
                    fontFamily: fontFamilyall,
                  }}
                >
                  {tableBatchCount(popupMsg)} record{tableBatchCount(popupMsg) === 1 ? "" : "s"}{" "}
                  added
                </Typography>

                <Button
                  size="small"
                  disabled={!popupActive || sending || tableBatchCount(popupMsg) === 0}
                  onClick={() => {
                    submitTableBatch(popupMsg);
                    setTablePopupId(null); // close popup once submitted
                  }}
                  sx={batchButtonSx}
                >
                  {batchButtonLabel(popupMsg, popupActive)}
                </Button>
              </Box>
            )}
          </Dialog>
        );
      })()}
    </Box>
  );
}